<template>
  <div class="firstPage">
    <div class="logo"></div>
    <div class="title"></div>
    <div class="login-box">
      <div class="left_img"></div>
      <div class="right_line">
        <div class="right_line_box">
          <div class="right_line_box_title">
            园区一体化监管平台
          </div>
          <div class="right_line_box_btn" @click="goLogin"></div>
        </div>
      </div>
    </div>
    <div class="login-box2">
      <div class="left_img2"></div>
      <div class="right_line2">
        <div class="right_line_box2">
          <div class="right_line_box_title">
            企业一体化监管平台
          </div>
          <div class="right_line_box_btn" @click="goLoginEnt"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goLogin() {
      this.$router.push({ path: '/loginPage' });
    },
    goLoginEnt() {
      window.location.href = 'http://ent.cghgyq.zwehs.com';
    }
  }
};
</script>
<style lang="less" scoped>
.firstPage {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('~assets/images/first_bg.png') no-repeat;
  background-size: 100% 100%;
}
.logo {
  position: absolute;
  width: 558px;
  height: 66px;
  top: 28px;
  left: 40px;
  background: url('~assets/images/logo_fushunheader.png') no-repeat;
}
.title {
  width: 856px;
  height: 218px;
  background: url('~assets/images/first_title.png') no-repeat;
  background-size: cover;
  position: absolute;
  top: 87px;
  left: 50%;
  margin-left: -428px;
  z-index: 11;
}
.login-box {
  z-index: 10;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: 28vh;
  right: 204px;
  width: 578px;
  height: 258px;
  backdrop-filter: blur(8px);
  .right_line {
    width: 510px;
    height: 190px;
    position: absolute;
    right: 0;
    bottom: 0;
    background: url('~assets/images/first_line.png') no-repeat;
    background-size: cover;
    .right_line_box {
      position: absolute;
      right: 78px;
      bottom: 54px;
      font-size: 28px;
      font-weight: 700;
      width: 260px;
      height: 90px;
    }
    .right_line_box_btn {
      width: 155px;
      height: 38px;
      margin-top: 15px;
      background: url('~assets/images/loging.png') no-repeat;
      &:hover {
        background: url('~assets/images/login_hover.png') no-repeat;
      }
    }
  }
  .left_img {
    width: 240px;
    height: 240px;
    background: url('~assets/images/park_logo.png') no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    background-size: cover;
  }
}
.login-box2 {
  z-index: 10;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: 58vh;
  right: 204px;
  width: 578px;
  height: 258px;
  backdrop-filter: blur(8px);
  .right_line2 {
    width: 510px;
    height: 190px;
    position: absolute;
    right: 0;
    bottom: 0;
    background: url('~assets/images/first_line.png') no-repeat;
    background-size: cover;
    .right_line_box2 {
      position: absolute;
      right: 78px;
      bottom: 54px;
      font-size: 28px;
      font-weight: 700;
      width: 260px;
      height: 90px;
    }
    .right_line_box_btn {
      width: 155px;
      height: 38px;
      margin-top: 15px;
      background: url('~assets/images/loging.png') no-repeat;
      &:hover {
        background: url('~assets/images/login_hover.png') no-repeat;
      }
    }
  }
  .left_img2 {
    width: 240px;
    height: 240px;
    background: url('~assets/images/enterprise_logo.png') no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    background-size: cover;
  }
}
</style>
